/* Linkify user text — the ONE UGC linkifier shared by every surface where one
   person's free text is shown to another (DMs, support chat, consult chat,
   comments). JS twin of PHP linkify_user_text() in app/helpers.php — keep the
   two in sync; LinkifyUserTextSyncTest asserts the regexes and the own-domain
   allowlist below still match their PHP counterparts.

   Returns a DocumentFragment: plain text stays in text nodes (XSS-proof by
   construction), URLs become anchors. Matched: http(s)://, www., and OWN bare
   domains (timbrica/tembrica.com) — a bare FOREIGN domain ("файл.info") must
   not become a link. Own links keep weight (rel=noopener); foreign ones are
   UGC: rel="ugc nofollow noopener noreferrer". Everything opens in a new tab.

   Lives in its own file rather than inside timbrica-core.js because the admin
   layout (admin/layout.blade.php → the /pino support inbox) does not load that
   274 KB bundle, and the support chat there needs to linkify too. */
window.__linkifyUserText = function (text) {
    var frag = document.createDocumentFragment();
    text = String(text == null ? '' : text);
    if (!text) return frag;
    var rx = /(?:https?:\/\/[^\s<>"']+|www\.[^\s<>"']+|(?:[a-z0-9-]+\.)*(?:timbrica|tembrica)\.com(?:\/[^\s<>"']*)?)/gi;
    var last = 0, m;
    while ((m = rx.exec(text)) !== null) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        last = m.index + m[0].length;
        var url = m[0], trail = '';
        while (url && /[).,!?…:;»”"'\]]$/.test(url)) {
            if (url.slice(-1) === ')' && (url.split('(').length - 1) >= (url.split(')').length - 1)) break;
            trail = url.slice(-1) + trail;
            url = url.slice(0, -1);
        }
        if (!url) { frag.appendChild(document.createTextNode(trail)); continue; }
        var href = url.indexOf('://') !== -1 ? url : 'https://' + url;
        var host = '';
        try { host = new URL(href).hostname.toLowerCase(); } catch (_) {}
        var own = /(^|\.)(timbrica|tembrica)\.com$/.test(host);
        var a = document.createElement('a');
        a.href = href;
        a.target = '_blank';
        a.rel = own ? 'noopener' : 'ugc nofollow noopener noreferrer';
        a.textContent = url;
        frag.appendChild(a);
        if (trail) frag.appendChild(document.createTextNode(trail));
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    return frag;
};

/* Fill `el` with `body`, linkified. The one helper every JS chat surface calls
   so a missing/blocked linkify script degrades to plain text instead of an
   empty bubble. */
window.__setLinkifiedText = function (el, body) {
    if (!el) return;
    el.textContent = '';
    if (body && window.__linkifyUserText) el.appendChild(window.__linkifyUserText(body));
    else el.textContent = body || '';
};
